import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { CreatePatientForm } from "types";
import { relationshipOptions } from "validations/patientSchemas";

function EmergencyContactSection() {
  const {
    control,
    formState: { errors },
  } = useFormContext<CreatePatientForm>();

  return (
    <Box className="space-y-6 mt-8">
      <Typography variant="h6" className="text-xl font-medium">
        Emergency Contact
      </Typography>

      <Box className="grid grid-cols-4 gap-4">
        <Controller
          name="emergencyContactName"
          control={control}
          render={({ field }) => (
            <TextField
              id="emergency-contact-name"
              label="Contact Name"
              variant="outlined"
              fullWidth
              error={!!errors.emergencyContactName}
              helperText={errors.emergencyContactName?.message as string}
              {...field}
            />
          )}
        />

        <Controller
          name="emergencyContactRelationship"
          control={control}
          render={({ field }) => (
            <FormControl
              fullWidth
              error={!!errors.emergencyContactRelationship}
            >
              <InputLabel id="emergency-relationship-label">
                Relationship
              </InputLabel>
              <Select
                labelId="emergency-relationship-label"
                id="emergency-relationship"
                label="Relationship"
                {...field}
                value={field.value || ""}
              >
                {relationshipOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
              {errors.emergencyContactRelationship && (
                <FormHelperText>
                  {errors.emergencyContactRelationship.message as string}
                </FormHelperText>
              )}
            </FormControl>
          )}
        />

        <Controller
          name="emergencyContactPhone"
          control={control}
          render={({ field }) => (
            <TextField
              id="emergency-contact-phone"
              label="Phone Number"
              variant="outlined"
              fullWidth
              error={!!errors.emergencyContactPhone}
              helperText={errors.emergencyContactPhone?.message as string}
              {...field}
            />
          )}
        />

        <Controller
          name="emergencyContactEmail"
          control={control}
          render={({ field }) => (
            <TextField
              id="emergency-contact-email"
              label="Email (optional)"
              variant="outlined"
              fullWidth
              error={!!errors.emergencyContactEmail}
              helperText={errors.emergencyContactEmail?.message as string}
              {...field}
            />
          )}
        />
      </Box>
    </Box>
  );
}

export default EmergencyContactSection;
